import React from "react";
import clsx from "clsx";

import styles from "./PhotoImg.module.scss";

type Props = {
  size?: number;
  src: string;
  alt?: string;
};

export default function PhotoImg({ size, src, alt }: Props) {
  const _size = size || 118;
  return (
    <div style={{ width: `${_size}px`, height: `${_size}px` }}>
      <img src={src} alt={alt} className={clsx(styles.img, "w-100 h-100")} />
    </div>
  );
}
